<template>
  <div id="bathUpdate">
    <a-modal :title="$t('pubGicSet.BathUpdate')" v-model="visible" width="60%">
      <template slot="footer">
        <a-row type="flex" justify="end">
          <function-bar
            @handleToolClick="handleSubmit"
            :buttonsObj="functionBtn"
          ></function-bar>
        </a-row>
      </template>
      <a-form :form="form">
        <a-row :gutter="24">
          <a-col :span="24" v-for="(item, index) in dataSearch" :key="index" v-if="item.disaplyable">
            <a-form-item
              v-bind="formItemLayout"
              :label="item.label === '' ? 'Title' : item.label"
            >
              <a-input
                size="small"
                v-if="item.fieldType == 'String'"
                :placeholder="item.label"
                :disabled="!item.editable"
                autocomplete="off"
                style="width: 80%"
                v-decorator="[
                  item.detailUid,
                  {
                    initialValue: item.DefaultValue,
                    rules: [
                      {
                        required: item.mandatory,
                        message: $t('publicLang.Required'),
                        max: item.FieldLength
                      }
                    ]
                  }
                ]"
              />
              <a-checkbox
                style="margin-left: 4px"
                v-model="item.checked"
                @change="changeCheckBox(item, index)"
              ></a-checkbox>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import ajax from "../../../api/ajax";
import api from "../../../api/url";
import functionBar from "../components/functionBar.vue";
export default {
  components: {
    functionBar
  },
  data() {
    return {
      visible: false,
      dataSearch: [],
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        }
      },
      form: this.$form.createForm(this),
      functionBtn: []
    };
  },
  methods: {
    changeCheckBox(item, index) {
      this.$forceUpdate();
    },
    open() {
      this.visible = true;
      ajax.post(api.POPUP, this.$parent.bathUpdatparams).then(res => {
        this.functionBtn = res.functionBtn;
        this.dataSearch = res.data;
        for (let ii in this.dataSearch) {
          this.dataSearch[ii].detailUid = this.dataSearch[ii].detailUid + "";
          this.dataSearch[ii].checked = true;
        }
      });
    },
    closeModal() {
      this.visible = false;
    },
    handleSubmit(val) {
      this.form.validateFields((err, values) => {
        let dataSearch = this.dataSearch;
        let paramsData = [];
        for (let ii in dataSearch) {
          for (let key in values) {
            if (dataSearch[ii].checked) {
              if (parseInt(dataSearch[ii].detailUid) == key) {
                let paramsObj = {};
                paramsObj.key = key;
                paramsObj.value = values[key];
                paramsData.push(paramsObj);
              }
            }
          }
        }
        let params = {
          behrUid: this.$parent.bathUpdatparams.btnUid,
          gmcUid: this.$parent.bathUpdatparams.gmcUid,
          params: paramsData.concat(this.$parent.bathUpdatparams.batchDataArr),
          type: "batch"
        };
        ajax.post(api.UPDATE, params).then(res => {
          if (res.code == 200) {
            this.closeModal();
            this.$emit("cancelModalVisible", "init");
          }
        });
      });
    }
  }
};
</script>
